"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wait = exports.update = exports.getError = exports.getStatus = exports.defined = exports.exist = exports.getExports = exports.getState = exports.register = exports.moduleMap = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _pendingFactory3 = _interopRequireDefault(require("./util/pendingFactory"));

/**
 * module status
 * loading: 1
 * loaded: 2
 * merged: 3
 * pending: 4
 * ready: 5
 * defined: 6
 * error: 7
 */
var moduleStateMap = {};
var pendingMap = {};
var moduleMap = {};
exports.moduleMap = moduleMap;

var register = function register(id) {
  if (moduleStateMap.hasOwnProperty(id)) {
    throw new Error("Module: ".concat(id, " existed"));
  }

  var moduleState = {
    status: 1,
    deps: [],
    factory: null,
    error: null,
    exports: undefined
  };
  return moduleStateMap[id] = moduleState;
};

exports.register = register;

var getState = function getState(id) {
  return moduleStateMap[id];
};

exports.getState = getState;

var getExports = function getExports(id) {
  return moduleMap[id];
};

exports.getExports = getExports;

var exist = function exist(id) {
  return moduleStateMap.hasOwnProperty(id);
};

exports.exist = exist;

var defined = function defined(id) {
  var _moduleStateMap$id;

  return ((_moduleStateMap$id = moduleStateMap[id]) === null || _moduleStateMap$id === void 0 ? void 0 : _moduleStateMap$id.status) >= 6;
};

exports.defined = defined;

var getStatus = function getStatus(id) {
  var _moduleStateMap$id2;

  return (_moduleStateMap$id2 = moduleStateMap[id]) === null || _moduleStateMap$id2 === void 0 ? void 0 : _moduleStateMap$id2.status;
};

exports.getStatus = getStatus;

var getError = function getError(id) {
  var _moduleStateMap$id3;

  return (_moduleStateMap$id3 = moduleStateMap[id]) === null || _moduleStateMap$id3 === void 0 ? void 0 : _moduleStateMap$id3.error;
};

exports.getError = getError;
var defaultModuleError = new Error('Module export error');

var update = function update(id, status, data) {
  var moduleStatus = getStatus(id);

  if (moduleStatus >= 6) {
    return;
  }

  var moduleState = getState(id);

  if (!moduleState) {
    moduleState = register(id);
  }

  Object.assign(moduleState, {
    status: status
  }, data);

  if (status === 6) {
    moduleMap[id] = moduleState.exports;
    Object.defineProperty(moduleMap, id, {
      writable: false,
      configurable: false
    });
  } else if (status === 7 && !moduleState.error) {
    moduleState.error = defaultModuleError;
  }

  var pendingQueue = pendingMap[id];

  if (pendingQueue) {
    new Array(status).fill(null).forEach(function (v, i) {
      var _pendingQueue$_status;

      var _status = i + 1;

      (_pendingQueue$_status = pendingQueue[_status]) === null || _pendingQueue$_status === void 0 ? void 0 : _pendingQueue$_status.forEach(function (job) {
        return status === 7 ? job.error(moduleState.error) : job.ready();
      });
      delete pendingQueue[_status];
    });
  }
};

exports.update = update;

var wait = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id, status, timeout) {
    var currentStatus, _pendingFactory, _pendingFactory2, pending, ready, error, job, timeoutTimer;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            currentStatus = getStatus(id);

            if (!(currentStatus == 7)) {
              _context.next = 3;
              break;
            }

            throw getError(id);

          case 3:
            if (!(currentStatus >= status)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            if (!pendingMap[id]) pendingMap[id] = {};
            if (!pendingMap[id][status]) pendingMap[id][status] = [];
            _pendingFactory = (0, _pendingFactory3.default)(), _pendingFactory2 = (0, _slicedToArray2.default)(_pendingFactory, 3), pending = _pendingFactory2[0], ready = _pendingFactory2[1], error = _pendingFactory2[2];
            job = {
              ready: ready,
              error: error
            };
            pendingMap[id][status].push(job);

            if (timeout) {
              timeoutTimer = setTimeout(function () {
                pendingMap[id][status] = pendingMap[id][status].filter(function (_job) {
                  return _job !== job;
                });
                error(new Error("Wait for module ".concat(id, " timeout")));
              }, timeout);
            }

            _context.prev = 11;
            _context.next = 14;
            return pending;

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](11);
            throw _context.t0;

          case 19:
            _context.prev = 19;

            if (timeoutTimer) {
              clearTimeout(timeoutTimer);
            }

            return _context.finish(19);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 16, 19, 22]]);
  }));

  return function wait(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.wait = wait;
//# sourceMappingURL=module.js.map